import { render } from "./Sub.vue?vue&type=template&id=199475f6&scoped=true"
import script from "./Sub.vue?vue&type=script&lang=js"
export * from "./Sub.vue?vue&type=script&lang=js"

import "./Sub.vue?vue&type=style&index=0&id=199475f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-199475f6"]])

export default __exports__